import request from '@/utils/request/index';

export function page(params) {
    return request({
        url: '/delegator-infos/page',
        method: 'GET',
        params: params
    });
}

export function save(params) {
    return request({
        url: '/delegator-infos/permissions',
        method: 'POST',
        data: params
    });
}

export function deleteById(id) {
    return request({
        url: '/delegator-infos/' + id,
        method: 'DELETE'
    });
}

export function updateById(id, params) {
    return request({
        url: '/delegator-infos/' + id + '/permissions/',
        method: 'PUT',
        data: params
    });
}

export function getRoles(id) {
    return request({
        url: '/users/getRoles/' + id,
        method: 'GET'
    });
}

export function setSubmitPermissions(params) {
    return request({
        url: '/delegator-permissions',
        method: 'POST',
        data: params
    });
}

export function getPermissions(params) {
    return request({
        url: '/delegator-permissions',
        method: 'GET',
        params: params
    });
}

export function changeUser(params) {
    return request({
        url: '/users/changeUser',
        method: 'POST',
        data: params
    });
}
